import { useRef, useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import EFVideo from '@/components/UI/EFVideo';

export default function B() {
    const { useLang } = useGlobal();
    const { t } = useLang('corporatesocialresponsibility');
    const videoRef = useRef<any>(null);
    const [playing, setPlaying] = useState(false);

    return (
        <div className={`csr-B ${css['csr-B']}`}>
            <div className="secB">
                <div className="desc desc1">{t('secB_desc1')}</div>
                <div className="text-img">
                    <NextImage
                        src={require('@publicLocal/corporate-social-responsibility/pc/power_for_all.png')}
                        alt={t('secB_desc1')}
                        aria-label={t('secB_desc1')}
                    />
                </div>
                <div className="desc desc2">{t('secB_desc2')}</div>
                <div className="video-wrapper">
                    <EFVideo
                        ref={videoRef}
                        className="video fullImgs"
                        sources={['/video/corporate-social-responsibility/power_for_all.mp4', '/video/corporate-social-responsibility/power_for_all.mp4']}
                        width="100%"
                        height="100%"
                        aria-label={t('secB_desc1')}
                        poster={'/media/corporate-social-responsibility/video_poster_pc.png'}
                        autoPlay={false}
                        loop={false}
                        // showReplay
                        onEnded={() => setPlaying(false)}
                        muted={false}
                        // @ts-ignore
                        controls={playing}
                    />
                    {!playing && (
                        <>
                            <div
                                className="play-icon"
                                onClick={() => {
                                    setPlaying(true);
                                    videoRef.current?.play();
                                }}
                            ></div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
                                <path
                                    d="M94.1667 49.8611C94.1667 74.3304 74.3304 94.1667 49.8611 94.1667C25.3918 94.1667 5.55557 74.3304 5.55557 49.8611C5.55557 25.3918 25.3918 5.55557 49.8611 5.55557C74.3304 5.55557 94.1667 25.3918 94.1667 49.8611Z"
                                    stroke="white"
                                    strokeWidth="2.22222"
                                />
                                <path
                                    d="M37.7783 67.9227V34.0886C37.7783 32.3267 39.7308 31.2655 41.2093 32.2239L66.1396 48.3835C67.4577 49.2378 67.4975 51.1526 66.2162 52.0611L41.2858 69.7356C39.8142 70.7789 37.7783 69.7266 37.7783 67.9227Z"
                                    fill="white"
                                />
                            </svg>
                        </>
                    )}
                </div>
                <p className="title">{t('secB_title')}</p>
                <div className="img">
                    <NextImage
                        webpSrc={require('@publicLocal/corporate-social-responsibility/pc/2.webp')}
                        src={require('@publicLocal/corporate-social-responsibility/pc/2.png')}
                        alt={t('secB_desc1')}
                        aria-label={t('secB_desc1')}
                    />
                    {new Array(15).fill(0).map((_: any, k: number) => (
                        <span className={`circle c${k + 1}`} key={k}>
                            <span className="inner"></span>
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}
